module.exports = __webpack_public_path__ + "media/images/team/JillEhrenreichMay-0215b4dad20cc93c01a0c2f5d1c111c4.png";